import z from 'zod';
import { QcsResourceSlice } from '../core/resourceSliceUtils';

export const MILEAGE_TRACKER_REDUCER_KEY = 'mileageTrackerStore';
export type MILEAGE_TRACKER_REDUCER_KEY = typeof MILEAGE_TRACKER_REDUCER_KEY;

const mileageTypeSchema = z.enum(['TRIP', 'MILES_ONLY']);
export type MileageTypeSchema = z.infer<typeof mileageTypeSchema>;

export const MileageTrackerSchema = z.object({
  id: z.string().optional(),
  type: mileageTypeSchema,
  clientId: z.string().optional(),
  createdAt: z.string().optional(),
  modifiedAt: z.string().optional(),
  postedOn: z.string().optional(),
  vehicleId: z.string().optional(), // TODO need to look at the vehicle entity and how we want to handle this
  startLocationId: z.string().nullable().optional(),
  endLocationId: z.string().nullable().optional(),
  distance: z.number(),
  value: z.number().optional(), // TODO check if this is gonna be from us or QCS
  roundTrip: z.boolean(),
  businessId: z.string().optional(),
  purposeId: z.string().optional(), // TODO check entity
  notes: z.string().optional(),
});

export type MileageTrackerType = z.infer<typeof MileageTrackerSchema>;

export type MileageTrackerState = QcsResourceSlice<MileageTrackerType>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [MILEAGE_TRACKER_REDUCER_KEY]: MileageTrackerState;
  }
}
